import axios from "axios";
import {
  AccountsandFinanceurl,
  customerservice,
  downloadIndividualClients,
  finsightsGatewayUrl,
  finsightsSetupUrl,
  getlogsUrl,
  mpesaServiceUrls,
  statementUploader,
  uploadIndividualClients,
} from "../../config";
import { generateAndExecuteMutation } from "../Axios/DynamicService";
import { Typography } from "@mui/material";

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json",
  };
};

const uploadReconFileAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "multipart/form-data",
  };
};

const downloadDocumentsAuthHeaders = () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  return {
    Authorization: formattedToken,
    "Content-Type": "application/json", // Set this to JSON for download requests
  };
};

export async function uploadReconFile(file, isGroup) {
  const baseurlupload =
    isGroup === 1
      ? AccountsandFinanceurl.upload_sms_file_uri
      : AccountsandFinanceurl.upload_file_uri;
  const headers = uploadReconFileAuthHeaders();
  const postData = {
    postedFile: file,
  };
  try {
    const response = await axios.post(baseurlupload, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}
export async function verifyGuarantor(row) {
  const headers = getAuthHeaders();
  const bool = row.IsActive === "False" ? true : false;
  const query = `
          mutation VerifyUnverifyGuarantor {
            verifyUnverifyGuarantor(guarantorId: ${row.Id}, isVerified: ${bool}) {
              results
              error
              totalCount
            }
          }
        `;
  try {
    const response = await fetch(customerservice.uri, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ query }),
    });
    const result = await response.json();
    return result.data.verifyUnverifyGuarantor;
  } catch (error) {
    console.error("Error verifying/unverifying guarantor:", error);
    throw error;
  }
}

export async function generateReports(parameters, reportUrl) {
  const headers = getAuthHeaders();
  const base_url = reportUrl;
  const postData = parameters;

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}
export async function getReconLogs() {
  const headers = getAuthHeaders(); // Ensure this function is correctly defined
  const base_url = getlogsUrl.uri; // Ensure `getlogsUrl.uri` is correctly set

  try {
    const response = await axios.get(base_url, { headers });

    // Step 1: Split log entries by new lines
    const rawLogs = response.data.logs.trim().split("\n");

    // Step 2: Convert each log entry into a JSON object
    const logsArray = rawLogs.map((log) => {
      const jsonPart = log.substring(0, log.lastIndexOf(" at ")).trim(); // Remove timestamp
      return JSON.parse(jsonPart); // Convert to JSON object
    });

    return logsArray; // ✅ Now an array of objects
  } catch (error) {
    console.error(
      "Error fetching logs:",
      error.response?.data || error.message,
    );
    return { error: error.response?.data || error.message }; // ✅ Return meaningful error
  }
}
export async function generateReport(formData, reportUrl, setLoading) {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const headers = {
    "Content-Type": "application/json",
    // Uncomment the following lines if you need these headers
    Authorization: formattedToken,
    "Access-Control-Allow-Headers": "authorization,content-type",
    "Access-Control-Allow-Methods": "POST",
    "Access-Control-Allow-Origin": "*",
    Origin: "https://api.sheriapro.sababisha.com",
    referrerPolicy: "no-referrer-when-downgrade",
  };

  try {
    // Start the loading animation
    setLoading(true);

    const response = await fetch(reportUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response;
  } catch (error) {
    console.error("Error:", error);
    return error;
  } finally {
    // Stop the loading animation
    setLoading(false);
  }
}

export async function mpesaPay(AmountToPay, phoneNumber) {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const headers = getAuthHeaders();
  const base_url = mpesaServiceUrls.smsPay;
  const Account = `MZW${parseInt(companyId)}`;
  const postData = {
    Account,
    AmountToPay,
    phoneNumber,
  };

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}
export async function mpesaPaySGW(AmountToPay, phoneNumber, companyId) {
  const headers = getAuthHeaders();
  const base_url = mpesaServiceUrls.smsPay;
  const Account = `SGW_${parseInt(companyId, 10)}`;
  const postData = {
    Account,
    AmountToPay,
    phoneNumber,
  };

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}
export async function mpesaPayFinsights(AmountToPay, phoneNumber) {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const companyId = parseInt(decodedToken.CompanyId);

  const headers = getAuthHeaders();
  const base_url = mpesaServiceUrls.smsPay;
  const Account = `fins_mzw${parseInt(companyId)}`;
  const postData = {
    Account,
    AmountToPay,
    phoneNumber,
  };

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}
export async function fetchFinsightsAuthToken() {
  try {
    const response = await axios.post(
      customerservice.generate_finsights_token_uri,
      {},
      { headers: getAuthHeaders() }
    );
    return response?.data?.success ? response.data.token : null;
  } catch (error) {
    return null;
  }
}

export async function fetchFinsightsTokenUsage() {
  const finsightsToken = await fetchFinsightsAuthToken();
  if (!finsightsToken) return null;

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const maziwaCompanyId = parseInt(decodedToken.CompanyId);

  const query = `
    query GeTokenUsageTrackers {
      tokenUsageTrackers {
        id
        token
        companyId
        userId
        isCompany
        maziwaCompanyId
        createdDate
        lastUpdatedDate
      }
    }
  `;

  try {
    const response = await axios.post(
      finsightsSetupUrl.setup,
      { query },
      {
        headers: {
          Authorization: `Bearer ${finsightsToken}`,
          "Content-Type": "application/json",
        },
      }
    );
    const records =
      response?.data?.data?.tokenUsageTrackers ??
      response?.data?.data?.getTokenUsageTracker ??
      response?.data?.data?.tokenUsageTracker;

    if (Array.isArray(records)) {
      if (!isNaN(maziwaCompanyId)) {
        const matched = records.find(
          (r) => Number(r.maziwaCompanyId) === maziwaCompanyId
        );
        if (matched) return matched;
      }
      return records[0] ?? null;
    }
    return records ?? null;
  } catch (error) {
    return null;
  }
}

export async function mpesaPay2(AmountToPay, phoneNumber) {
  const headers = getAuthHeaders();
  const base_url = mpesaServiceUrls.smsPay;
  const PaymentType = 2;
  const postData = {
    PaymentType,
    AmountToPay,
    phoneNumber,
  };

  try {
    const response = await axios.post(base_url, postData, { headers });
    return response;
  } catch (error) {
    return error.code;
  }
}

export async function UploadStatement(values) {
  const { file, password, customerId } = values;
  if (!file) throw new Error("No file provided for upload.");
  if (!password || String(password).trim() === "")
    throw new Error("Password is missing or empty.");
  if (!customerId) throw new Error("Customer ID is missing.");

  const formData = new FormData();
  formData.append("file", file);
  formData.append("password", String(password));
  formData.append("customerId", customerId);

  // Log FormData for debugging
  for (let [key, value] of formData.entries()) {
    console.log(`${key}: ${value}`);
  }

  try {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const response = await axios.post(customerservice.statement, formData, {
      headers: {
        Authorization: formattedToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*", // Allows requests from any origin
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS", // Allows specific HTTP methods
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
        Origin: "https://finsights.mcb.co.ke/", // Allows specific headers
      },
    });

    if (response.data && response.data.success === false) {
      const err = new Error(response.data.message || "Statement upload failed.");
      err.response = response;
      err.data = response.data;
      throw err;
    }

    return response.data;
  } catch (error) {
    console.error(
      "Error uploading the document:",
      error.response?.data || error.message,
    );
    throw error;
  }
}

export async function fetchStatementProgress(statementId) {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;
  const base_url = customerservice.statement_progress;

  try {
    const response = await axios.post(
      `${base_url}?statementId=${statementId}`,
      null, // no body needed — your API reads statementId from the query string
      {
        headers: {
          Authorization: formattedToken,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching statement progress:", error?.response?.data || error.message);
    return null;
  }
}
export async function ViewStatatementDetails(formData, reportUrl, setLoading) {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const headers = {
    "Content-Type": "application/json",
    // Uncomment the following lines if you need these headers
    Authorization: formattedToken,
    "Access-Control-Allow-Headers": "authorization,content-type",
    "Access-Control-Allow-Methods": "POST",
    "Access-Control-Allow-Origin": "*",
    Origin: "https://api.sheriapro.sababisha.com",
    referrerPolicy: "no-referrer-when-downgrade",
  };

  try {
    // Start the loading animation
    setLoading(true);

    const response = await fetch(reportUrl, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response;
  } catch (error) {
    console.error("Error:", error);
    return error;
  } finally {
    // Stop the loading animation
    setLoading(false);
  }
}

export async function UploadBankStatement(values) {
  const { file, password, bankid, bankstatemanttypeid } = values;

  // Check if the necessary fields are provided
  if (!file) throw new Error("No file provided for upload.");
  if (!password) throw new Error("Password is missing.");
  if (!bankid) throw new Error("Bank ID is missing.");
  if (!bankstatemanttypeid)
    throw new Error("Bank statement type ID is missing.");

  const formData = new FormData();

  // Append the necessary fields to the form data
  formData.append("file", file);
  formData.append("password", password);
  formData.append("bankid", bankid);
  formData.append("bankstatementtypeid", bankstatemanttypeid);

  try {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const response = await axios.post(statementUploader.bank_url, formData, {
      headers: {
        Authorization: formattedToken,
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "*", // Allows requests from any origin
        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS", // Allows specific HTTP methods
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
        Origin: "https://finsights.mcb.co.ke/", // Allows specific headers
      },
    });
    return response.status;
  } catch (error) {
    console.error("Error uploading the document:", error);
    throw error;
  }
}
